/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/MsftRectButton',['pixi', 'absolute', 'lodash', 'MenuUI/MsftButton'],

    function (PIXI, Absolute, _, MsftButton) {

        var MsftRectButton = function(options) {
            this._initMsftRectButton(options);
        };

        MsftRectButton.constructor = MsftRectButton;
        MsftRectButton.prototype = Object.create(MsftButton.prototype);

        MsftRectButton.prototype._initMsftRectButton = function(options) {
            MsftButton.call(this, options);
        };

        MsftRectButton.prototype._createTexture = function(threeSliceOptions, type) {

            var container = new PIXI.DisplayObjectContainer(),
                rect = new PIXI.Graphics();

            rect.beginFill(this.options.rect[type + '_color'], 1);
            rect.drawRect(0,0,this.options.width, this.options.height);
            rect.endFill();

            var labelBitmapText = new PIXI.Text(this.options.text, this.options.letterStyle),
                labelSprite = new PIXI.Sprite(labelBitmapText.generateTexture());

            labelSprite.anchor.x = labelSprite.anchor.y = 0.5;

            labelSprite.x = this.options.width / 2;
            labelSprite.y = this.options.height / 2;

            container.addChild(rect);
            container.addChild(labelSprite);

            return container.generateTexture();
        };

        MsftRectButton.prototype.destroy = function() {
            if (this.threeSlice) {
                this.threeSlice.destroy();
            }
        };

        return MsftRectButton;

    });

